/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ matched: NonNullable<unknown>, created: NonNullable<unknown>, decks: NonNullable<unknown> }} Offline_Go_Online_SummaryInputs */



/**
* | output |
* | --- |
* | "Back online — {matched} player(s) matched to existing members, {created} new member(s) created, {decks} deck(s) synced." |
*
* @param {Offline_Go_Online_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_go_online_summary = /** @type {((inputs: Offline_Go_Online_SummaryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Go_Online_SummaryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`De nouveau en ligne — ${i?.matched} joueur(s) associés à des membres existants, ${i?.created} nouveaux membre(s) créés, ${i?.decks} deck(s) synchronisés.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`De nuevo en línea — ${i?.matched} jugador/es asociados a miembros existentes, ${i?.created} nuevos miembro/s creados, ${i?.decks} deck(s) sincronizados.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`De volta online — ${i?.matched} jogador/es associados a membros existentes, ${i?.created} novos membro/s criados, ${i?.decks} deck(s) sincronizados.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Di nuovo online — ${i?.matched} giocatore/i associati a membri esistenti, ${i?.created} nuovi membro/i creati, ${i?.decks} deck sincronizzati.`)
	return /** @type {LocalizedString} */ (`Back online — ${i?.matched} player(s) matched to existing members, ${i?.created} new member(s) created, ${i?.decks} deck(s) synced.`)
});